module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-9.21f46eb7.png";